import { clsx } from "clsx";
import type { InputHTMLAttributes, SelectHTMLAttributes } from "react";

import { cn } from "@/lib/cn";

// Defaults bake in ``w-full``. Per-instance overrides like ``className="w-20"``
// win because :func:`cn` runs through ``tailwind-merge``, which resolves
// conflicting Tailwind utilities by keeping the later one.
const FIELD_BASE =
  "w-full rounded-md border border-border bg-surface-base px-2.5 py-1.5 text-sm " +
  "text-foreground-primary placeholder:text-foreground-muted " +
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent";

export function TextInput(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={cn(FIELD_BASE, props.className)} />;
}

export function NumberInput(props: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      type="number"
      {...props}
      className={cn(FIELD_BASE, "tabular-nums", props.className)}
    />
  );
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select {...props} className={cn(FIELD_BASE, "appearance-none pr-8", props.className)} />
  );
}

export function Label({
  children,
  className,
  htmlFor,
}: {
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
}) {
  return (
    <label
      htmlFor={htmlFor}
      className={clsx(
        "block text-2xs uppercase tracking-wider text-foreground-muted",
        className,
      )}
    >
      {children}
    </label>
  );
}
